<template>
  <div class="loading-box">
    <div class="loading-content" style=" text-align: center;">
      <div class="ant-spin ant-spin-lg ant-spin-spinning"><span class="ant-spin-dot ant-spin-dot-spin"><i
        class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i
        class="ant-spin-dot-item"></i></span></div>
    </div>
  </div>

</template>

<script>
  export default {
    name: "loading"
  }
</script>

<style lang="scss" scoped>
  @import "@/styles/variable-color.scss";

  .loading-box{
    position: fixed;
    top:calc(50vh - 36px);
    left: calc(50vw - 16px);
  }
  @keyframes antdDrawerFadeIn {
    0% {
      opacity: 0
    }
    to {
      opacity: 1
    }
  }

  .ant-spin {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.42;
    list-style: none;
    font-feature-settings: "tnum";
    position: absolute;
    display: none;
    @include color_primary(color_primary_dark); //边框

    /*color: #fe346e;*/

    text-align: center;
    vertical-align: middle;
    z-index: 999;
    opacity: 0;
    transition: transform .3s cubic-bezier(.78, .14, .15, .86)
  }

  .ant-spin-spinning {
    position: static;
    display: inline-block;
    opacity: 1
  }



  .ant-spin-container {
    position: relative;
    transition: opacity .3s
  }

  .ant-spin-container:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
    display: none \9;
    width: 100%;
    height: 100%;
    background: #fff;
    opacity: 0;
    transition: all .3s;
    content: "";
    pointer-events: none
  }

  .ant-spin-blur {
    clear: both;
    overflow: hidden;
    opacity: .5;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    pointer-events: none
  }

  .ant-spin-blur:after {
    opacity: .4;
    pointer-events: auto
  }

  .ant-spin-tip {
    color: #8a8e99
  }

  .ant-spin-dot {
    position: relative;
    display: inline-block;
    font-size: 20px;
    width: 1em;
    height: 1em
  }

  .ant-spin-dot-item {
    position: absolute;
    display: block;
    width: 9px;
    height: 9px;
    @include bg_color_primary(color_primary_dark); //边框
    /*background-color: #fe346e;*/
    border-radius: 100%;
    transform: scale(.7);
    transform-origin: 50% 50%;
    opacity: .3;
    animation: antSpinMove 1s linear infinite alternate
  }

  .ant-spin-dot-item:first-child {
    top: 0;
    left: 0
  }

  .ant-spin-dot-item:nth-child(2) {
    top: 0;
    right: 0;
    animation-delay: .4s
  }

  .ant-spin-dot-item:nth-child(3) {
    right: 0;
    bottom: 0;
    animation-delay: .8s
  }

  .ant-spin-dot-item:nth-child(4) {
    bottom: 0;
    left: 0;
    animation-delay: 1.2s
  }

  .ant-spin-dot-spin {
    transform: rotate(45deg);
    animation: antRotate 1.2s linear infinite
  }

  .ant-spin-lg .ant-spin-dot {
    font-size: 32px
  }

  .ant-spin-lg .ant-spin-dot i {
    width: 16px;
    height:16px;
  }

  @media (-ms-high-contrast: active),(-ms-high-contrast: none) {
    .ant-spin-blur {
      background: #fff;
      opacity: .5
    }
  }

  @keyframes antSpinMove {
    to {
      opacity: 1
    }
  }

  @keyframes antRotate {
    to {
      transform: rotate(405deg)
    }
  }

</style>
